import React from "react";
import styled from "@emotion/styled";
import {useColorMode} from "theme-ui";
import mediaqueries from "@styles/media";

interface LinkProps {
  href: string,
  text: string
}

const Link: React.FC<LinkProps> = (props) => {
  const [colorMode] = useColorMode();
  const isDark = colorMode === "dark";
  return (
    <>
      <div>
        <LinkText href={props.href} isDark={isDark}>
          {props.text}
        </LinkText>
      </div>
    </>
  );
};

const LinkText = styled.a<{ isDark: boolean; }>`
  font-size: 18px;
  line-height: 165.5%;
  letter-spacing: -.04em;
  color: #ffffff;

  ${mediaqueries.desktop`
    font-size: 16px;
  `};
`;

export default Link;
